import { Skeleton } from "antd-mobile";
import { memo } from "react";
import type { FC, ReactNode } from "react";

interface IProps {
    children?: ReactNode;
}

const TokenHeaderSkeleton: FC<IProps> = () => {
    return (
        <div className="flex items-center justify-center">
            <Skeleton animated className={"rounded-[40px] w-[40px] h-[40px]"} />
            <div className="ml-[10px]">
                <Skeleton
                    animated
                    className={"w-[52px] h-[24px] rounded-[2px]"}
                />
                <div className="h-[2px]"></div>
                <Skeleton
                    animated
                    className={"w-[64px] h-[14px] rounded-[2px]"}
                />
            </div>
        </div>
    );
};

export default memo(TokenHeaderSkeleton);
